import PropTypes from 'prop-types';
import classNames from 'classnames';

import { GalleryArrowRight, GalleryArrowLeft } from '../icons/GalleryArrow';
import {
  GalleryArrowWithBackgroundRight,
  GalleryArrowWithBackgroundLeft
} from '../icons/GalleryArrowWithBackground';

import { useMediaQuery } from '../utils/breakpoints/breakpoints';

import styles from './GalleryArrow.module.scss';

const GalleryArrow = ({
  navRole,
  onClick,
  style = 'small',
  dataTest = '',
  withBackground = false,
  className = ''
}) => {
  const LeftChevronIcon = withBackground
    ? GalleryArrowWithBackgroundLeft
    : GalleryArrowLeft;
  const RightChevronIcon = withBackground
    ? GalleryArrowWithBackgroundRight
    : GalleryArrowRight;

  const mediaQueries = useMediaQuery();

  const handleMouseDown = () => {
    onClick();
  };

  const galleryArrowClasses = classNames(
    styles['gallery-arrow'],
    styles[`gallery-arrow--${navRole}`],
    className
  );

  const handlers = mediaQueries.isBiggerThanTablet()
    ? {
        onMouseDown: handleMouseDown
      }
    : {
        onTouchStart: handleMouseDown
      };

  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className={galleryArrowClasses}>
      <div
        {...handlers}
        onClick={handleClick}
        role="button"
        tabIndex="0"
        className={classNames(styles.pointer, {
          [styles['pointer--small']]: style === 'small' && !withBackground,
          [styles['pointer--big']]: style === 'big' && !withBackground,
          [styles['pointer--with-background']]: withBackground
        })}
        data-test={dataTest}
      >
        {navRole === 'next' ? (
          <RightChevronIcon className={classNames(styles['pointer--next'])} />
        ) : (
          <LeftChevronIcon className={classNames(styles['pointer--prev'])} />
        )}
      </div>
    </div>
  );
};

GalleryArrow.propTypes = {
  navRole: PropTypes.oneOf(['next', 'prev']).isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.oneOf(['small', 'big']),
  dataTest: PropTypes.string,
  withBackground: PropTypes.bool,
  className: PropTypes.string
};

export default GalleryArrow;
